module.exports = __webpack_public_path__ + "media/audio7.bae93cbe.mp3";